import React from 'react';
import './about.scss';
// import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FiChevronRight } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import MaroofAwaisQarni from '../Assets/About/MaroofAwaisQarni.jpeg'
import MuhammadSiddiq from '../Assets/About/MuhammadSiddiq.jpg'
import Francescs from '../Assets/About/Francesca.jpeg'
import Joy from '../Assets/About/Joy.jpeg'
const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | World Adventures Tours</title>
        <meta name="description" content="Learn about World Adventures Tours — a registered tour company in Gilgit-Baltistan offering adventure travel, mountaineering support, cultural tours, and more across Pakistan." />
        <meta name="keywords" content="About World Adventures Tours, Pakistan travel agency, Gilgit Baltistan tours, adventure travel Pakistan, trekking company Pakistan" />
        <meta property="og:title" content="About Us | World Adventures Tours" />
        <meta property="og:description" content="World Adventures Tours is a government-licensed company offering authentic adventure and cultural tours across Pakistan's northern regions. Explore our values and services." />
        <meta property="og:url" content="https://www.worldadventurestours.com/About" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.worldadventurestours.com/About" />
      </Helmet>
      <div className="overview-container">
        <h2 className="overview-title">About Us</h2>

        <div className="overview-section">
          <h3>Who Are We?</h3>
          <p>
            We the ‘World Adventures Tours’ is a fresh and young team of human lovers willing to spread and share the wonders of this earth with every single explorer. Officially registered with the Government of Gilgit-Baltistan under license number <strong>DTS-GB-021</strong>, we are fully authorized to operate tourism services across the region. We are trying hard to connect the entire world on the basis of humanity and believe that every citizen of this planet should have the right of freedom to explore the beauty of universe with peace and choice. As a licensed company, we aim to provide safe, reliable, and memorable journeys to our clients. We are optimistic for the travelers in gaining an easy access to walk from one corner to another delighting the nature glee. The ‘World Adventure Tours’ is based in Gilgit-Baltistan territory of Pakistan.

            Our basic values are trust, commitment and flexibility sharing the glee of nature. We have great trust in our staff & the services we offer and want our clients to trust us for more than ever. We are highly committed to provide best tours and adventure experiences to our clients in Pakistan.
          </p>
        </div>
        <div className="key-highlights">
          <h3>✅ Services Provided by Us</h3>
          <ul>
            <li>
              <FiChevronRight />
              <strong>Adventure Tours</strong>Guided treks to iconic destinations like K2 Base Camp, Concordia, and beyond.
            </li>
            <li>
              <FiChevronRight />
              <strong>Mountaineering Support</strong>Base camp management, porters, and guides for climbing expeditions.
            </li>
            <li>
              <FiChevronRight />
              <strong>Cultural and Heritage Tours</strong>Explore the rich history, architecture, and traditions of Baltistan and Gilgit regions
            </li>
            <li>
              <FiChevronRight />
              <strong>Camping & Trekking Equipment</strong>High-quality gear for trekking, camping, and base camp experiences.
            </li>
            <li>
              <FiChevronRight />
              <strong>Hotels Booking</strong> Verified stays from budget to luxury accommodations across Northern Pakistan.
            </li>
            <li>
              <FiChevronRight />
              <strong>Permit Assistance</strong> Help with obtaining travel permits and NOCs for restricted zones.
            </li>
          </ul>
        </div>

        <div className="who-is-it-for">
          <h3>🌍 Why Choose World Adventures Tours?</h3>
          <ul>
            <strong>✅ Government Registered & Licensed:</strong><br />
            <li>
              <FaArrowRight />
              We are a fully registered travel company under license number DTS-GB-021, authorized by the Department of Tourism Gilgit-Baltistan, ensuring credibility, safety, and professionalism.
            </li>
            <strong>🕰️ Over 10 Years of Experience:</strong><br />
            <li>
              <FaArrowRight />
              With more than a decade of experience, we’ve been proudly serving adventurers, trekkers, and cultural explorers with expert planning and flawless execution.
            </li>
            <strong>🗺️ Based in the Heart of the Mountains:</strong><br />

            <li>
              <FaArrowRight />
              Our operations are located in Gilgit-Baltistan,Pakistan home to K2, Nanga Parbat, Gandogoro and some of the other world’s most stunning landscapes.
            </li>
            <strong>🧭 Local Expertise with Global Standards:</strong><br />

            <li>
              <FaArrowRight />
              Our team consists of experienced, passionate locals who understand the terrain, culture, and hospitality, and provide services that meet international standards.
            </li>
            <strong>🌐 International Guides Available:</strong><br />
            <li>
              <FaArrowRight />
              For global travelers, we provide international guides fluent in multiple languages for seamless communication and cultural understanding.
            </li>
            <strong>🏔️ Adventure & Cultural Tour Specialists:</strong><br />
            <li>
              <FaArrowRight />
              From trekking and mountaineering to heritage and jeep safaris, we offer a wide variety of custom tour experiences.
            </li>
            <strong>🛡️ Safety Comes First:</strong><br />
            <li>
              <FaArrowRight />
              All tours are led by experienced guides with proper safety gear and emergency protocols in place.
            </li>
            <strong>🤝 Trusted by Travelers Worldwide:</strong><br />
            <li>
              <FaArrowRight />
              We’ve earned the trust of clients across the globe with our honesty, professionalism, and unforgettable hospitality.
            </li>
            <strong>💬 24/7 Support:</strong><br />
            <li>
              <FaArrowRight />
              Our team is available around the clock to assist before, during, and even after your journey.
            </li>
          </ul>
        </div>
        <div className="overview-section">
          <h3>✨ Our Mission & Vision</h3>
          <h4>Our Mission</h4>
          <p>
            At World Adventure Tours, our mission is to inspire and empower individuals from around the globe to explore the breathtaking landscapes, rich cultures, and hidden gems of Pakistan — especially the majestic region of Gilgit-Baltistan. We are dedicated to promoting responsible tourism, cultural harmony, and sustainable exploration by providing safe, meaningful, and unforgettable experiences. We strive to be a bridge between people and nature, helping travelers create memories that last a lifetime.
          </p>
          <h4>Our Vision</h4>
          <p>
            We envision a world where every person — regardless of nationality — has the freedom and opportunity to experience the natural wonders of the Earth with peace, safety, and joy. As a government-registered and licensed company (License No: DTS-GB-021), our long-term goal is to become a leading adventure travel brand recognized not only for our exceptional services but also for our deep commitment to cultural respect, environmental care, and social impact. We aim to expand globally while staying rooted in the values of humanity, trust, and shared joy.
          </p>
        </div>

      </div>
      <div className="team">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <img src={MuhammadSiddiq} alt="Muhammad Siddiq" />
            <h3>Muhammad Siddiq</h3>
            <p>Chief Executive Officer (CEO)</p>
            <div className="social-links">
              <a href="https://www.facebook.com/gungree" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/chogo-ree-siddiq-812658225/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/chogoree?igsh=N2s2cmQ2eWVocG16" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="team-member">
            <img src={MaroofAwaisQarni} alt="Maroof Awais Qarni" />
            <h3>Maroof Awais Qarni</h3>
            <p>Managing Director (MD)</p>
            <div className="social-links">
              <a href="https://www.facebook.com/mr.awaisqarnii" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/maroofawaisqarni/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/mr_awaisqarni?igsh=cHp1OW9qeWt4YWlk" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>
            <div className="team-member">
            <img src={Francescs} alt="Francesca Lollio" />
            <h3>Francesca Lollio</h3>
            <p>Europe Representative</p>
            <div className="social-links">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/francesca-lollio-34965710b/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/francescs.lollio" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>

            <div className="team-member">
            <img src={Joy} alt="Joy Lim" />
            <h3>Joy Lim</h3>
            <p>Singapore Representative</p>
            <div className="social-links">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>

            {/* <div className="team-member">
            <img src={MaroofAwaisQarni} alt="Qamar Ali" />
            <h3>Qamar Ali</h3>
            <p>Transport Manager</p>
            <div className="social-links">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
};

export default About;
